import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
    width: 'inherit',
  },
  submitButton: {
    margin: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  element: {
    display: 'flex',
    "& .MuiAutocomplete-root": {
      width: '100%'
    }
  },
  elementGroup: {
    display: 'flex',
  },
  alignHorizontal: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexGrow: 100,
  },
  formElement: {
    margin: theme.spacing(1),
    minWidth: 180,
    fontSize: 'min(3vw, 16px)',
    "& .react-tel-input": {
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      "& input": {
        width: "100%"
      }
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 80,
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 8px"
    },
    "& .form-control": {
      padding: "8px 8px 8px 50px"
    },
    "& .MuiInputLabel-outlined": {
      transform: "translate(8px, 8px) scale(1)"
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingTop: "0px !important",
      paddingBottom: "0px !important"
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(12px, -6px) scale(1)",
      fontSize: 'min(2vw, 12px)'
    }
    
  },
  formIconButton: {
    margin: theme.spacing(0.5),
    minWidth: 25,
    minHeight: 25
  }
}));

export default useStyles;
